import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/gchammas23/portfolio'
      className='link footer__link'
    >
      Created Gabriel Chammas
    </a>
  </footer>
)

export default Footer
